import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getQuizEvents } from './quizEventsAsync';
import Reducers from "types/Reducers";
import IQuizEvent from "models/QuizEvent";
import QuizEventStatuses from "types/QuizEventStatuses";

interface IState {
  quizEvents: IQuizEvent[] | null;
};

const initialState:IState = {
  quizEvents: null,
};

const slice = createSlice({
  name: Reducers.QuizEvents,
  initialState,
  reducers: {
    triggerQuizEvent: (state, action:PayloadAction<string>) => {
      if (state.quizEvents) {
        state.quizEvents = state.quizEvents.map(quizEvent => {
          if (quizEvent.id === action.payload) {
            return { ...quizEvent, status: QuizEventStatuses.Triggered }
          }
          return quizEvent;
        })
      }
    }
  },
  extraReducers(builder) {
    // Get quiz events
    builder.addCase(getQuizEvents.pending, (state) => {
      state.quizEvents = null;
    });
    builder.addCase(getQuizEvents.fulfilled, (state, action:PayloadAction<IQuizEvent[]>) => {
      state.quizEvents = action.payload;
    });
  },
});

export const { triggerQuizEvent } = slice.actions;

export default slice.reducer;
